import script from "./MicrochipResultView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MicrochipResultView.vue?vue&type=script&setup=true&lang=ts"

import "./MicrochipResultView.vue?vue&type=style&index=0&id=c8feba12&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src839921157/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8feba12"]])

export default __exports__